import { FC } from "react"
import { ImageProps } from "./models"

export const Image: FC<ImageProps> = (props) => {
  const { alt = "", className, onClick, src } = props
  return <img alt={alt} className={className} onClick={onClick} src={src} />
}
